<template>
    <div @click="onClick">
        <ag-grid-vue ref="agGridTable"
            class="w-full wizard-table ag-theme-material  my-4 ag-grid-table ap_ag_grid acu_dashboard_tbl"
            :defaultColDef="defaultColDef" :rowData="items" colResizeDefault="shift" domLayout="autoHeight"
            @grid-ready="onGridReady" :enableRtl="$vs.rtl" @cell-clicked="onCellClicked"
            :suppressDragLeaveHidesColumns="true" :suppressAggFuncInHeader="true" :suppressPaginationPanel="true"
            :suppressRowClickSelection="true" :pagination="true" :animateRows="true"
            :columnDefs="modifiedHeaders"></ag-grid-vue>

        <!-- Popup -->
        <div v-if="showPopup" :style="{ top: popupPosition.top + 'px', left: popupPosition.left + 'px' }"
            class="info-popup">
            <div>
                <div class="hover-popup">
                    <p class="description">This access point will include the following configuration</p>

                    <div v-if="currentData?.data?.readers">
                        <div v-for="(item, index) in currentData.data.readers" :key="index">
                            <h6 class="title">Reader {{ index + 1 }}</h6>
                            <h6 class="description">Port {{ TEMPLATE_INFO["reader"][item.port]?.label || "N/A" }}</h6>
                            <h6 class="description">
                                Direction {{ TEMPLATE_INFO["reader"]["direction"][item.direction] || "N/A" }}
                            </h6>
                        </div>
                    </div>

                    <div v-if="currentData && currentData.data.resources">
                        <div v-for="(item, index) in Object.keys(currentData.data.resources)" :key="item">
                            <h6 class="title">{{ RESOURCES[item]?.label || "Resource" }} {{ index + 1 }}</h6>
                            <div v-if="currentData.data.resources[item].input">
                                <h6 class="description">
                                    Connection Pin
                                    {{
                                        currentData.data.resources[item].component_source == "0"
                                            ? TEMPLATE_INFO["input"]["0"][currentData.data.resources[item].input]?.label ||
                                            "CUSTOM"
                                            : currentData.data.resources[item].input
                                    }}
                                </h6>
                            </div>
                            <div v-else>
                                <h6 class="description">
                                    Connection Output
                                    {{
                                        currentData.data.resources[item].component_source == "0"
                                            ? TEMPLATE_INFO["output"]["0"][currentData.data.resources[item].output]?.label ||
                                            " "
                                            : currentData.data.resources[item].output
                                    }}
                                </h6>
                                <h6 class="description">
                                    Lock Type {{
                                        TEMPLATE_INFO["output"]['relay_mode'][currentData.data.resources[item].relay_mode
                                        ].label ||
                                        "N/A" }}
                                </h6>
                                <h6 class="description">
                                    Duration of Hold {{ currentData.data.resources[item].entry_exit_open_durations }}
                                    seconds
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import CellRendererTemplateActions from "../../renderer/CellRendererTemplateActions";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { RESOURCES, TEMPLATE_INFO } from "../constants";


export default {
    props: {
        headers: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
        selectAcu: {
            type: Function,
            default: (e) => { },
        },
    },
    computed: {
        modifiedHeaders() {
            return this.headers.map((header) => ({
                ...header,
                cellClassRules: {
                    "selected-cell": (params) =>
                        this.selectedCell &&
                        this.selectedCell.rowIndex === params.node.rowIndex &&
                        this.selectedCell.field === params.colDef.field,
                },
            }));
        },
    },
    components: {
        AgGridVue,
        CellRendererTemplateActions,
    },
    data() {
        return {
            TEMPLATE_INFO,
            RESOURCES,
            currentData: null,
            showPopup: false,
            popupPosition: { top: 0, left: 0 },
            popupData: null,
            selectedCell: null,
            gridApi: null,
            gridColumnApi: null,
            defaultColDef: {
                sortable: true,
                resizable: true,
                lockPinned: true,
            },
            opacity_table: false,
        };
    },

    methods: {
        onClick() {
            this.showPopup = false;
        },
        cleanup() {
            this.currentData = null;
            this.showPopup = false;
            this.popupPosition = { top: 0, left: 0 };
            this.popupData = null;
            this.selectedCell = null;

        },
        onCellClicked(params) {
            if (params.column.colId === "actions") {
                return null
            }
            const data = { ...params.data }
            if (typeof data.data == "string") {
                data.data = JSON.parse(data.data)
            }
            if (data.data.resources && typeof data.data.resources == "string") {
                data.data.resources = JSON.parse(data.data.resources)
            }
            this.currentData = data;
            const cellElement = params.event.path ? params.event.path[0] : params.event.target;
            const gridElement = this.$refs.agGridTable.$el;

            if (!gridElement) return;

            const boundingRect = gridElement.getBoundingClientRect();
            const cellRect = cellElement.getBoundingClientRect();
            
            if (cellRect && boundingRect) {
                const tableRect = gridElement.getBoundingClientRect(); // Get the table position

                this.$set(this, "popupPosition", {
                    top:data.access_point_type.startsWith('turnstile')?  -60: -20,
                    left: 468 / 2
                });
            } else {
                return;
            }

            this.showPopup = this.showPopup ? null : params.data.id;
        },
        onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            this.autoSizeAll();
        },
        handleWindowResize() {
            this.autoSizeAll();
        },
        autoSizeAll() {
            this.gridApi.sizeColumnsToFit();
            this.$vs.loading.close();
            this.opacity_table = true;
        },
    },
    mounted() {
        setTimeout(() => {
            this.autoSizeAll()
        }, 800)
    },
    created() {
        window.addEventListener("resize", this.handleWindowResize);
        this.autoSizeAll()
        this.$root.$on("agGridTableTemplate", () => {
            this.opacity_table = false;
            this.autoSizeAll();
            this.$vs.loading.close();
        });
    },
};
</script>

</script>

<style lang="scss">
.wizard-table {
    max-height: 450px;
    min-height: 340px;
    overflow-y: auto;
}

.info-popup {
    position: absolute;
    background-color: #262c49;
    border: none;
    border-radius: 4px;
    padding: 10px;
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

    .title {
        color: #0CA2CD;
        font-size: 14px;
        text-align: left;
        font-weight: 600;
        margin-bottom: 4px;
    }

    .description {
        margin-bottom: 4px;
        text-align: left;
        font-size: 12px;
        color: #fff;
        font-weight: 400;
    }
}
</style>